(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip-components/assets/javascripts/views/pay-button.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip-components/assets/javascripts/views/pay-button.js');
"use strict";

var _svs$core$config$data, _svs$core$config$data2;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useContext = _React.useContext,
  useEffect = _React.useEffect,
  useState = _React.useState;
const useIsAtBottomWindow = svs.components.tipsen.hooks.useIsAtBottomWindow;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const selectActiveWallet = svs.components.tipsen.walletSelectors.selectActiveWallet;
const PaymentContext = svs.components.tipsen.couponId.PaymentContext;
const Betslip = svs.components.tipsen.betslipComponents.Betslip;
const selectIsKeyLoading = svs.components.tipsen.loadingState.selectors.selectIsKeyLoading;
const LoadingKeys = svs.components.tipsen.loadingState.constants.LoadingKeys;
const _svs$components$tipse = svs.components.tipsen.hooks,
  useIsCurrentDrawPlayable = _svs$components$tipse.useIsCurrentDrawPlayable,
  useGetMarketplaceWalletPaid = _svs$components$tipse.useGetMarketplaceWalletPaid;
const isSelfService = (_svs$core$config$data = (_svs$core$config$data2 = svs.core.config.data.svsconfig) === null || _svs$core$config$data2 === void 0 ? void 0 : _svs$core$config$data2.isSelfService) !== null && _svs$core$config$data !== void 0 ? _svs$core$config$data : false;
const getLogger = svs.core.log.getLogger;
const wagerLogger = getLogger('tipsen:wager');
const WrapLoginLink = svs.components.lbUtils.wrapLoginLink.WrapLoginLink;
const _svs$components$sport = svs.components.sport.tipsenShared,
  actions = _svs$components$sport.actions,
  PARAM_ACTION = _svs$components$sport.PARAM_ACTION;
const roles = [svs.core.userSession.roles.PLAYER, svs.core.userSession.roles.RETAILER]; 

const defaultReturnRoles = [];
const payButtonScrollEvent = new CustomEvent('payButtonScroll');
const PayButton = () => {
  const isDrawPlayable = useIsCurrentDrawPlayable();
  const _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    hasAdditions = _useState2[0],
    setHasAdditions = _useState2[1];
  const isLoggedIn = !svs.core.userSession.isAnonymous();
  const activeWallet = useSelector(selectActiveWallet);
  const placeBet = useContext(PaymentContext);
  const isAtBottom = useIsAtBottomWindow();
  const isLoadingPix = useSelector(state => selectIsKeyLoading(state, LoadingKeys.PIX));
  const hasActiveMarketplaceWalletPaid = useGetMarketplaceWalletPaid();
  const isDisabled = () => {
    if (!isDrawPlayable || isLoadingPix || hasActiveMarketplaceWalletPaid) {
      return true;
    }
    if (isLoggedIn) {
      return !activeWallet;
    }
    return false;
  };
  const isScrollToBottomNeeded = hasAdditions && !isAtBottom;
  const handlePay = () => {
    if (isScrollToBottomNeeded) {
      window.dispatchEvent(payButtonScrollEvent);
      window.scrollTo({
        left: 0,
        top: document.body.scrollHeight,
        behavior: 'smooth'
      });
    } else {
      wagerLogger.info('PlaceBet button clicked');
      placeBet();
    }
  };
  let betslipLabel = 'Betala';
  if (isSelfService) {
    betslipLabel = 'Lägg i varukorgen';
  } else if (isScrollToBottomNeeded) {
    betslipLabel = 'Till betalning';
  }
  useEffect(() => {
    const additions = document.querySelector('.tipsen-additions');
    if (!additions) {
      setHasAdditions(false);
    }
  }, []);
  const qs = new URLSearchParams(window.location.search);
  qs.set(PARAM_ACTION, actions.PAY);
  const returnUrl = "".concat(window.location.pathname, "?").concat(encodeURIComponent(qs));

  const isFocused = isSelfService ? !isScrollToBottomNeeded : true;
  return React.createElement(WrapLoginLink, {
    classes: "pg_betslip__login_button",
    isDisabledWrapper: isScrollToBottomNeeded,
    returnUrl: returnUrl,
    roles: isScrollToBottomNeeded ? defaultReturnRoles : roles
  }, React.createElement(Betslip.PayButtonDisplay, {
    betslipLabel: betslipLabel,
    handlePay: handlePay,
    hasScrollDownIcon: isScrollToBottomNeeded,
    isDisabled: isDisabled(),
    isFocused: isFocused
  }));
};
Betslip.PayButton = PayButton;

 })(window);